import React from 'react'
import image from '../../assets/images/new_logo.png'

const Header = () => {
  return (
    <div className="col-12">
        <nav className="navbar navbar-expand-md navbar-light">

            <a className="navbar-brand" href="https://suntrustng.com/" target="_self"><img
                    src={image} alt=""/></a>

            <button className="navbar-toggler ref" type="button" data-bs-toggle="collapse"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse ref" id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto py-4 py-md-0">
                    <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                        <a href="https://suntrustng.com/"
                            className="btn btn-block btn-suntrust font-weight-900">Home</a>
                    </li>
                </ul>
            </div>

        </nav>
    </div>
   

  )
}

export default Header